import * as React from 'react';
import { connect } from 'react-redux';
import DataTable from '../../DataTable';
import moment from 'moment';
import SelectList from '../../RBSelectList/RBSelectList';
import { IAuditLog, ILogType } from '../common/defaults';
import { getLogTypes, getLogsByType } from '../redux-objects/actions';
import { Button, Modal } from 'react-bootstrap';
import ReactDOM from 'react-dom';
import AuditLogFilters from './AuditLogFilters';
import { elasticRequest } from '../../../services/elasticService';

const $ = require('jquery');
$.DataTable = require('datatables.net-bs4');

export interface IAuditLogActionProps {
  getLogTypes?: (url: string) => void;
  getLogsByType?: (url: string, type: string, filter: any) => void;
}

interface IAuditLogStateProps {
  logs: IAuditLog[];
  logTypes: ILogType[];
  selectedLogType: ILogType;
  columns: any;
  elasticSearchURL: string;
}

interface IAuditLogViewerProps
  extends IAuditLogActionProps,
  IAuditLogStateProps { }

const initialState = {
  logData: [],
  tableColumns: [],
  logTypes: [],
  selectedLogTypeValue: '-1',
  tableKey: 1,
  showModal: false,
  selectedLog: null,
};
type AuditLogVieiwerState = Readonly<typeof initialState>;

class AuditLogViewer extends React.Component<
  IAuditLogViewerProps,
  AuditLogVieiwerState
> {
  public constructor(props: IAuditLogViewerProps) {
    super(props);
    this.state = initialState;
  }

  closeModal = (e?) => {
    this.setState({
      showModal: false,
    });
  };

  handleLogTypeChange(event: React.ChangeEvent<HTMLInputElement>) {
    const value = event.target.value;
    this.setState(
      {
        selectedLogTypeValue: value,
      },
      () => {
        // We would want to trigger a populate on the type change, however if the log type has a
        // created_date, then it will trigger the filter when first rendered.  As of now I expect all our logs
        // to have a created_date.  In the future we could add a custom property to the log type to know if it will
        // filter upon rendering and use that info to determine whether to render here, upon type change
        // * If this is un-commented out it will still work, but it will search twice.
        //this.populateTable();
      }
    );
  }

  populateTable(mustQuery?: any) {
    const type = this.state.selectedLogTypeValue;
    const logIndex = `${this.props.elasticSearchURL}${type}*/_search?size=1000`;
    this.props.getLogsByType(logIndex, type, mustQuery);
  }

  componentDidMount() {
    this.props.getLogTypes(
      this.props.elasticSearchURL + 'logtype/_search?size=100'
    );
  }

  handleView(event: React.MouseEvent<HTMLElement>, fullLogData: any) {
    this.setState({
      selectedLog: fullLogData,
      showModal: true,
    });
  }

  filter(mustQuery: any) {
    this.populateTable(mustQuery);
  }

  public render() {
    const options = {
      dom: 'Bfrtip',
    };

    const columnDefs = [
      {
        targets: 0,
        width: '120px',
        orderable: false,
        createdCell: (td, cellData, rowData, row, col) =>
          ReactDOM.render(
            <div>
              <Button
                variant='outline-primary'
                size='sm'
                data-id={cellData}
                onClick={(e) => this.handleView(cellData, rowData)}
              >
                {' '}
                View Full Log
              </Button>
            </div>,
            td
          ),
      },
    ];

    if (this.props.columns && this.props.columns.length > 0) {
      if (this.props.columns.filter((x) => x.data === 'id').length === 0) {
        this.props.columns.unshift({
          title: '',
          data: 'id',
        });
      }
      let i = 0;
      for (i = 0; i < this.props.columns.length; i++) {
        if (this.props.columns[i].datatype == 'date') {
          var dateDef = {
            targets: i,
            render: function (data) {
              return moment(data).format('YYYY-MM-DD HH:mm:ss');
            },
            createdCell: null,
            width: null,
            orderable: true,
          };
          columnDefs.push(dateDef);
        }
      }
    }

    return (
      <div className='app'>
        <div className='row'>
          {this.props.logTypes.length > 0 && (
            <SelectList
              className='w-25'
              data={this.props.logTypes.sort((a, b) => (a.name > b.name) ? 1 : -1)}
              onChange={(e) => this.handleLogTypeChange(e)}
              value={this.state.selectedLogTypeValue}
              placeholder='Select a Log Type'
            />
          )}
          <br />
          <br />
        </div>
        {this.state.selectedLogTypeValue != '-1' && (
          <div>
            {this.props.logTypes.length > 0 && (
              <div className='row'>
                <AuditLogFilters
                  logtypename={this.state.selectedLogTypeValue}
                  key={this.state.selectedLogTypeValue}
                  filters={
                    this.props.logTypes.filter(
                      (x) => x.value === this.state.selectedLogTypeValue
                    )[0].filters
                  }
                  onFilter={(e) => this.filter(e)}
                />
                <hr />
              </div>
            )}
            {this.props.columns &&
              this.props.columns.length > 0 &&
              this.props.logs.length > 0 && (
                <DataTable
                  key={this.props.selectedLogType.value}
                  id='tblAuditViewer'
                  data={this.props.logs}
                  columns={this.props.columns}
                  columnDefs={columnDefs}
                  actionsColumn='first'
                  {...options}
                />
              )}
            {this.props.columns &&
              this.props.columns.length > 0 &&
              (!this.props.logs || this.props.logs.length == 0) && (
                <div>
                  <br />
                  <br />
                  <p className='text-center'>
                    No logs found with this criteria
                  </p>
                </div>
              )}

            <Modal show={this.state.showModal} onHide={this.closeModal}>
              <Modal.Header closeButton>
                <Modal.Title> Full Log Details</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div>
                  <pre>{JSON.stringify(this.state.selectedLog, null, 4)}</pre>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button variant='secondary' onClick={this.closeModal}>
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    logTypes: state.auditLogs.logTypes,
    logs: state.auditLogs.logs,
    columns: state.auditLogs.columns,
    selectedLogType: state.auditLogs.selectedLogType,
    elasticSearchURL: state.Application.elasticSearchURL,
  };
};

const mapDispatchToProps = {
  getLogTypes,
  getLogsByType,
};

export default connect(mapStateToProps, mapDispatchToProps)(AuditLogViewer);
